import { useMutation } from "react-query";
import {
  VehicleLicensePlateRequestParams,
  changeVehicleLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const changeVehicleLicensePlateFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehicleLicensePlateRequestParams;
}) => {
  return await changeVehicleLicensePlate(rowVersion, params);
};

export function useChangeVehicleLicensePlate() {
  return useMutation(changeVehicleLicensePlateFn, {
    mutationKey: MUTATION_KEYS.changeVehicleLicensePlate,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
